import { render } from "./InputElementsComponent.vue?vue&type=template&id=f18015c4"
import script from "./InputElementsComponent.vue?vue&type=script&lang=js"
export * from "./InputElementsComponent.vue?vue&type=script&lang=js"

import "./InputElementsComponent.vue?vue&type=style&index=0&id=f18015c4&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__